export const ChallengeDifficulty = {
  very_easy: "Very easy",
  easy: "Easy",
  medium: "Medium",
  hard: "Hard",
};

export const CodingRoundScreens = {
  HOME: 'HOME',
  COMPANIES: 'COMPANIES',
  TOPICS: 'TOPICS',
  CHALLENGES: 'CHALLENGES',
  PERSONALIZED: 'PERSONALIZED'
}

export const AttemptStates = {
  FEEDBACK_GENERATED : 'feedback_generated',
  FEEDBACK_PENDING : 'feedback_pending',
  FEEDBACK_SKIPPED : 'feedback_skipped'
};

export const AssessmentEntryPoint = {
  PERSONALIZED: 'personalized',
  COMPANY: 'company',
  CONTEST: 'contest',
  GENERAL_DSA: 'general_dsa',
  MOCK: 'mock'
}